import React, { useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Products from './components/Products';
import Customers from './components/Customers';
import FarmGallery from './components/FarmGallery';
import Location from './components/Location';
import Story from './components/Story';
import Certifications from './components/Certifications';
import Contact from './components/Contact';
import Footer from './components/Footer';
import FeedbackForm from './components/FeedbackForm';
import './App.css';

function App() {
  useEffect(() => {
    // Disable browser scroll restoration
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    // Force top on mount
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, []);
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <Products />
      <Customers />
      <FarmGallery />
      <Location />
      {/* <Contact /> */}
      <Story />
      <Certifications />
      <Footer />
      <FeedbackForm />
    </div>
  );
}

export default App;
